import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { PermissionService } from '../services/permission.service';
import { ROUTE_PERMISSIONS } from '../constants/permission-matrix.constant';

export const permissionGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot
) => {
  const router = inject(Router);
  const permissionService = inject(PermissionService);

  // Initialize permission service if not already initialized
  await permissionService.initialize();

  // Get the current URL path
  const currentUrl = router.url || window.location.pathname;
  const routePath = route.routeConfig?.path || '';
  const fullPath = route.url.map((segment) => segment.path).join('/');

  // Try multiple path formats to match route permissions
  const normalizedPath = '/' + (fullPath || routePath);
  const urlPath = currentUrl.split('?')[0]; // Remove query params

  // Check route permissions using multiple path formats
  const requiredPermissions =
    ROUTE_PERMISSIONS[normalizedPath] ||
    ROUTE_PERMISSIONS[urlPath] ||
    ROUTE_PERMISSIONS[currentUrl];

  // If no permissions required, allow access
  if (!requiredPermissions || requiredPermissions.length === 0) {
    return true;
  }

  // Check if user has required permissions
  const hasAccess = permissionService.hasAnyPermission(requiredPermissions);

  if (!hasAccess) {
    const currentUrl = router.url;
    const isOnErrorPage = currentUrl.includes('/error/403');

    // Only redirect if not already on the error page (prevents redirect loops)
    if (!isOnErrorPage) {
      router.navigate(['/error/403'], { replaceUrl: true });
    }
    return false;
  }

  return true;
};
